export enum ApiErrors {
  HasOrderLinesError = 'ErrHasOrderLinesError',
  ErrAllowedMaxFileSizeExceeded = 'ErrAllowedMaxFileSizeExceeded'
}
